import { createAction, props } from '@ngrx/store';
import { UploadExternalData } from "../models";

export enum ExternalVnaActions {
    OPEN_TOOLUPLOAD_DIALOG = '[Se] seOpenTooluploadDialog'
}

export const seOpenTooluploadDialog = createAction(ExternalVnaActions.OPEN_TOOLUPLOAD_DIALOG, props<{ data: UploadExternalData }>());

